import { render, staticRenderFns } from "./select-language.vue?vue&type=template&id=3fe56b09&scoped=true"
import script from "./select-language.vue?vue&type=script&lang=js"
export * from "./select-language.vue?vue&type=script&lang=js"
import style0 from "./select-language.vue?vue&type=style&index=0&id=3fe56b09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe56b09",
  null
  
)

export default component.exports